import React from 'react'
 import {IoLogoUsd} from "react-icons/io"

const MyAccount = (props) => {
    const sepoliaBalance =  parseFloat(props.Ethbalance);
    
    const bscBalance  = parseFloat(props.bscBalance);
  
    const erc20TokenBalance = parseFloat(props.dioBalance)
    const ethUsd = props.EthUsd;
    const bnbUsd  =props.BnbUsd;
    const Sepoliausd = sepoliaBalance*ethUsd;
    const bscUsd = bscBalance*bnbUsd;
    
    const totalBalance  =  Sepoliausd + bscUsd ;
    const USDBALANCE = parseFloat(totalBalance).toFixed(2);
    return (
        <div className="flex  justify-center gap-2 items-center p-10  bg-slate-100 shadow-md rounded-md ">
            {/* <img className="object-cover w-28 h-28 mt-6 rounded-full shadow-lg" src="https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80" alt="avatar" /> */}
            {/* <h4 className="  text-black font-bold mt-8  text-lg ">John Doe</h4> */}
            <div >
              <IoLogoUsd size={90} color="green"/>
            </div>
           <div>
           <p className="  text-black md:text-4xl  ">Total Balance :</p>
            <p className="     text-black  text-3xl ">${USDBALANCE}</p>
           </div>
           
        </div>
    )
}

export default MyAccount